import type { ReactNode } from "react";

import { Bold } from "@components/Text";
import { SsnInput } from "@components/Form";

import type { Form } from "./types";

const LABEL_REQUIRED = "Field is required";

type Props = {
  form: Form;
  path: string[];
  required?: boolean;
  itemProps?: Record<string, unknown>;
  inputProps?: Record<string, unknown>;
};

const InvestorSsnNumber = ({
  form,
  path,
  required = false,
  itemProps = {},
  inputProps = {},
}: Props) => {
  itemProps.label = <Bold>{itemProps.label as ReactNode}</Bold>;

  if (required) {
    itemProps.rules = [{
      required: true,
      message: LABEL_REQUIRED,
    }];
  }

  itemProps.name = path;
  itemProps.validateTrigger = "onBlur";

  return (
    <SsnInput
      form={form}
      path={path}
      itemProps={itemProps}
      inputProps={inputProps}
    />
  );
};

export default InvestorSsnNumber;
